<template>
    <div>
        <div v-if="confirmingMode">
            <slot name="confirm"></slot>
            <slot name="cancel" v-bind="{hideConfirm}"></slot>
        </div>
        <slot v-else name="default" v-bind="{showConfirm}"></slot>
    </div>
</template>

<script>
export default {
    name: "ButtonConfirmation",
    data: () => ({
        confirmingMode: false,
    }),
    methods: {
        showConfirm() {
            this.confirmingMode = true;
        },
        hideConfirm() {
            this.confirmingMode = false;
        }
    }
}
</script>

<style scoped>

</style>